import React from 'react'
import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons'
import { Label, Icon } from './InputErrorMessage.styles'

export interface InputErrorMessage {
  name: string
  inputId: string
  className?: string
  errors?: {
    [key: string]: {
      message?: string
    }
  }
}
const InputErrorMessage = ({ errors, name, inputId, className }: InputErrorMessage) => {
  const message = errors?.[name]?.message
  return message ? (
    <Label htmlFor={inputId} className={className}>
      <Icon icon={faExclamationCircle} />
      {message}
    </Label>
  ) : null
}

export default InputErrorMessage
